//new vue structure
import Vue from 'vue'
import vueResource from 'vue-resource'
// import VeeValidate from 'vee-validate'
import Clipboard from 'v-clipboard'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(vueResource)
// Vue.use(VeeValidate)
Vue.use(Clipboard)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  template: `
    <div id="app">
      <router-view></router-view>
    </div>
    `
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js